
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { ClientApi, SystemApi, GetHrCriterion, GetHrCriterionItem, GetHrCriterionCriteriaItem } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
import IconButton from "@/components/atoms/IconButton.vue";
type Criteria = GetHrCriterionCriteriaItem & { id?: number };
type FormValues = { name: string; criteria: Criteria[] };
@Options({
  components: {
    Field,
    Form,
    FieldLabel,
    FieldError,
    ActionButton,
    FormError,
    IconButton
  }
})
export default class HrCriterionForm extends FormMixin {
  @Prop({ type: Object }) criterion?: GetHrCriterion;
  formName = "人材基準";
  formValues: FormValues = { name: "", criteria: [] };
  criteria!: GetHrCriterionItem[];
  validationSchema!: yup.AnyObjectSchema;
  async beforeCreate() {
    this.validationSchema = yup.object({
      name: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "人材基準名" })),
      criteria: yup.array().of(
        yup.object().shape({
          code: yup.string().required(this.$t("input_required", { field: "基準" })),
          thresholdMin: yup
            .number()
            .nullable(true)
            .transform(v => (v === "" || Number.isNaN(v) ? null : v))
            .required(this.$t("input_required", { field: "閾値 (最小)" }))
            .min(0, this.$t("input_min", { field: "閾値 (最小)", value: "0" }))
            .max(100, this.$t("input_max", { field: "閾値 (最小)", value: "100" })),
          thresholdMax: yup
            .number()
            .nullable(true)
            .transform(v => (v === "" || Number.isNaN(v) ? null : v))
            .required(this.$t("input_required", { field: "閾値 (最大)" }))
            .min(0, this.$t("input_min", { field: "閾値 (最大)", value: "0" }))
            .max(100, this.$t("input_max", { field: "閾値 (最大)", value: "100" }))
            // @ts-ignore
            .when("thresholdMin", (min, schema) => schema.min(min, this.$t("input_min", { field: "閾値 (最大)", value: min })))
        })
      )
    });
  }
  async beforeMount() {
    const response = await new SystemApi().getHrCriteriaList({});
    this.criteria = response.data;
    this.formValues = this.criterion
      ? {
          name: this.criterion.name,
          criteria: JSON.parse(JSON.stringify(this.criterion.criteria))
        }
      : { name: "", criteria: [] };
  }
  async onBeforeSubmit(values: FormValues) {
    let criteria = values.criteria;
    if (criteria && criteria.length) {
      criteria = criteria.map(criterion =>
        Object.assign({}, criterion, {
          thresholdMin: parseFloat((criterion.thresholdMin as unknown) as string),
          thresholdMax: parseFloat((criterion.thresholdMax as unknown) as string)
        })
      );
    }
    await this.onSubmit(async () => {
      if (this.criterion) {
        await new ClientApi().updateHrCriteria({
          hrCriterionId: this.criterion.id,
          body: { name: values.name, criteria }
        });
      } else {
        await new ClientApi().createHrCriteria({
          createHrCriteriaRequest: { name: values.name, criteria }
        });
      }
      this.$emit("submitted");
    });
  }
  async onDeleteButtonClick() {
    this.onDelete(async () => {
      await new ClientApi().deleteHrCriteria({
        hrCriterionId: this.criterion!.id
      });
    });
  }
  onCriterionAddButtonClick() {
    this.formValues.criteria.push({
      code: "",
      thresholdMin: 0,
      thresholdMax: 100,
      id: Date.now()
    });
  }
  onCriterionDeleteButtonClick(item: GetHrCriterionCriteriaItem) {
    const index = this.formValues.criteria.indexOf(item);
    this.formValues.criteria.splice(index, 1);
  }
}
